import Auth from "./middleware/Auth";
import Login from "./middleware/Login";
import UsrSystem from "./middleware/UsrSystem";

const routes = [
  //orders
  {
    path: "/ordenes",
    name: "orders",
    component: () => import("@/views/orders/List.vue"),
    meta: {
      title: "Ordenes",
      middleware: UsrSystem,
    },
  },
  {
    path: "/ordenes/:id",
    name: "orders/show",
    component: () => import("@/views/orders/Show.vue"),
    meta: {
      title: "Orden",
      middleware: UsrSystem,
    },
  },
  //payments
  {
    path: "/pagos",
    name: "payments",
    component: () => import("@/views/payments/List.vue"),
    meta: {
      title: "Pagos",
      middleware: UsrSystem,
    },
  },
  {
    path: "/pagos/agregar",
    name: "payments/store",
    component: () => import("@/views/payments/Form.vue"),
    meta: {
      title: "Pago | Agregar",
      middleware: UsrSystem,
    },
  },
  {
    path: "/pagos/:id",
    name: "payments/show",
    component: () => import("@/views/payments/Show.vue"),
    meta: {
      title: "Pago",
      middleware: UsrSystem,
    },
  },
  {
    path: "/pagos/:id/editar",
    name: "payments/update",
    component: () => import("@/views/payments/Form.vue"),
    meta: {
      title: "Pago | Editar",
      middleware: UsrSystem,
    },
  },
  //vendors
  {
    path: "/proveedores_admin",
    name: "vendors",
    component: () => import("@/views/vendors/List.vue"),
    meta: {
      title: "Proveedores admin.",
      middleware: UsrSystem,
    },
  },
  {
    path: "/proveedores_admin/agregar",
    name: "vendors/store",
    component: () => import("@/views/vendors/Form.vue"),
    meta: {
      title: "Proveedor admin. | Agregar",
      middleware: UsrSystem,
    },
  },
  {
    path: "/proveedores_admin/:id",
    name: "vendors/show",
    component: () => import("@/views/vendors/Show.vue"),
    meta: {
      title: "Proveedor admin.",
      middleware: UsrSystem,
    },
  },
  {
    path: "/proveedores_admin/:id/editar",
    name: "vendors/update",
    component: () => import("@/views/vendors/Form.vue"),
    meta: {
      title: "Proveedor admin. | Editar",
      middleware: UsrSystem,
    },
  },
  {
    path: "/proveedores_admin/cuentas",
    name: "debit_accounts",
    component: () => import("@/views/vendors/DebitAccount.vue"),
    meta: {
      title: "Cuentas pagadoras",
      middleware: UsrSystem,
    },
  },
  //buscador
  {
    path: "/buscador",
    name: "finder",
    component: () => import("@/views/finder/Index.vue"),
    meta: {
      title: "Buscador",
      middleware: UsrSystem,
    },
  },
  {
    path: "/buscador/medico",
    name: "finder.doctor",
    component: () => import("@/views/finder/Doctor.vue"),
    meta: {
      title: "Buscador | Médico",
      middleware: UsrSystem,
    },
  },
  {
    path: "/buscador/proveedor",
    name: "finder.provider",
    component: () => import("@/views/finder/Provider.vue"),
    meta: {
      title: "Buscador | Proveedor",
      middleware: UsrSystem,
    },
  },
  {
    path: "/buscador/proveedor_facturas",
    name: "finder.provider_bills",
    component: () => import("@/views/finder/ProviderBills.vue"),
    meta: {
      title: "Buscador | Proveedores fondeo | promesa de pago",
      middleware: UsrSystem,
    },
  },
  {
    path: "/buscador/folio_fiscal",
    name: "finder.fiscal_folio",
    component: () => import("@/views/finder/FiscalFolio.vue"),
    meta: {
      title: "Buscador | Folio fiscal",
      middleware: UsrSystem,
    },
  },
  {
    path: "/buscador/serv_terminados_pend_confirm",
    name: "finder.discharge_pending_confirmation",
    component: () => import("@/views/finder/DischargePendingConfirmation.vue"),
    meta: {
      title: "Buscador | Serv. terminados pend. confirm.",
      middleware: UsrSystem,
    },
  },

  //employee_payroll_reviews
  {
    path: "/admin_nomina",
    name: "employee_payroll_reviews",
    component: () => import("@/views/employees/EmployeePayrollReviews.vue"),
    meta: {
      title: "Admin. Nómina",
      icon: "mdi-account-cash",
      middleware: UsrSystem,
    },
  },

  //employees
  {
    path: "/seguimiento-renovacion-contratos",
    name: "employee_contract_renewals",
    component: () => import("@/views/employees/contractRenewals/List.vue"),
    meta: {
      title: "Sgto. de renovación de contratos",
      middleware: UsrSystem,
    },
  },

  {
    path: "/empleados/avisos",
    name: "employee_announcements",
    component: () => import("@/views/employees/EmployeeAnnouncements.vue"),
    meta: {
      title: "Avisos portal empleados",
      icon: "mdi-bullhorn",
    },
  },
  // {
  //   path: "/empleados/correos_contratos_firmados",
  //   name: "employee_contract_email_recipients",
  //   component: () =>
  //     import("@/views/employees/EmployeeContractEmailRecipients.vue"),
  //   meta: {
  //     title: "Correos para contratos firmados",
  //     icon: "mdi-email-outline",
  //     middleware: UsrSystem,
  //   },
  // },
  {
    path: "/empleados/documentos",
    name: "employee_document_types",
    component: () => import("@/views/employees/EmployeeDocumentTypes.vue"),
    meta: {
      title: "Tipos de documento",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados/oficinas",
    name: "employee_offices",
    component: () => import("@/views/employees/EmployeeOffices.vue"),
    meta: {
      title: "Oficinas",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados/puestos",
    name: "employee_positions",
    component: () => import("@/views/employees/EmployeePosition.vue"),
    meta: {
      title: "Puestos",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados",
    name: "employees",
    component: () => import("@/views/employees/List.vue"),
    meta: {
      title: "Empleados",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados/agregar",
    name: "employees/add",
    component: () => import("@/views/employees/Form.vue"),
    meta: {
      title: "Empleado Agregar",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados/:id",
    name: "employees/show",
    component: () => import("@/views/employees/Show.vue"),
    meta: {
      title: "Empleado",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados/:id/editar",
    name: "employees/update",
    component: () => import("@/views/employees/Form.vue"),
    meta: {
      title: "Empleado | Editar",
      middleware: UsrSystem,
    },
  },
  {
    path: "/empleados/:id/contratos",
    name: "employee_contracts",
    component: () => import("@/views/employees/EmployeeContracts.vue"),
    meta: {
      title: "Contratos",
      middleware: UsrSystem,
    },
  },
  //bills
  {
    path: "/facturacion",
    name: "bills",
    component: () => import("@/views/bills/Index.vue"),
    meta: {
      title: "Facturación",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/apa",
    name: "bills.ipa",
    component: () => import("@/views/bills/Ipa.vue"),
    meta: {
      title: "Facturación | AP AETNA",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/documentacion_multifactura",
    name: "bills.pharmacy_multi_documentations",
    component: () =>
      import("@/views/bills/pharmacyMultiDocumentations/List.vue"),
    meta: {
      title: "Facturación | Documentación Multifactura",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/documentacion_multifactura/:id",
    name: "bills.pharmacy_multi_documentations.show",
    component: () =>
      import("@/views/bills/pharmacyMultiDocumentations/Show.vue"),
    meta: {
      title: "Facturación | Documentación Multifactura",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/pago_multifactura",
    name: "bills.multipayments",
    component: () => import("@/views/bills/Multipayments.vue"),
    meta: {
      title: "Facturación | Pago Multifactura",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/reporte_ingresos",
    name: "bills.rha_report",
    component: () => import("@/views/bills/RhaReport.vue"),
    meta: {
      title: "Facturación | Reporte ingresos",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/reporte_folio_proveedor_duplicado",
    name: "bills.rha_provider_duplicate_report",
    component: () => import("@/views/bills/RhaProviderDuplicateReport.vue"),
    meta: {
      title: "Facturación | Reporte folio proveedor duplicado",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/reporte_pendientes_pago",
    name: "bills.rha_pending_payment_report",
    component: () => import("@/views/bills/RhaPendingPaymentReport.vue"),
    meta: {
      title: "Facturación | Reporte pendientes pago",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/reporte_pagos_diferencia",
    name: "bills.rha_paid_difference_report",
    component: () => import("@/views/bills/RhaPaidDifferenceReport.vue"),
    meta: {
      title: "Facturación | Reporte pagos con diferencia",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/revision_cartera",
    name: "bills.rha_collection_review_report",
    component: () => import("@/views/bills/RhaCollectionReviewReport.vue"),
    meta: {
      title: "Facturación | Revisión de cartera",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/revision_cancelaciones",
    name: "bills.rha_facturapi_cancel_review",
    component: () => import("@/views/bills/RhaFacturapiCancelReview.vue"),
    meta: {
      title: "Facturación | Revisión de cancelaciones",
      middleware: UsrSystem,
    },
  },
  {
    path: "/facturacion/reporte_servicios",
    name: "bills.rs_report",
    component: () => import("@/views/bills/RsReport.vue"),
    meta: {
      title: "Facturación | Reporte Servicios",
      middleware: UsrSystem,
    },
  },
  //rs_services
  {
    path: "/servicios",
    name: "rs_services",
    component: () => import("@/views/rs_services/Index.vue"),
    meta: {
      title: "Servicios",
      middleware: UsrSystem,
    },
  },
  {
    path: "/servicios/cppd",
    name: "rs_services.cppd",
    component: () => import("@/views/rs_services/Cppd.vue"),
    meta: {
      title: "Servicios | CPPD",
      middleware: UsrSystem,
    },
  },
  {
    path: "/servicios/cppd/:id",
    name: "rs_services.cppd_store_doctor",
    component: () => import("@/views/rs_services/CppdStoreDoctor.vue"),
    meta: {
      title: "Servicio | CPPD",
      middleware: UsrSystem,
    },
    props: true,
  },
  {
    path: "/servicios/cppd_pagos",
    name: "rs_services.cppd_payments",
    component: () => import("@/views/rs_services/CppdPayments.vue"),
    meta: {
      title: "Servicios | CPPD Pagos",
      middleware: UsrSystem,
    },
  },
  {
    path: "/servicios/telemedicina",
    name: "rs_services.telemedicine",
    component: () => import("@/views/rs_services/Telemedicine.vue"),
    meta: {
      title: "Telemédicina",
      middleware: UsrSystem,
    },
  },
  //rhas
  {
    path: "/ingresos",
    name: "rhas",
    component: () => import("@/views/rhas/Index.vue"),
    meta: {
      title: "Ingresos",
      middleware: UsrSystem,
    },
  },
  {
    path: "/ingresos/rbdc",
    name: "rhas.rbdc",
    component: () => import("@/views/rhas/Rbdc.vue"),
    meta: {
      title: "Control de costos con aclaración",
      middleware: UsrSystem,
    },
  },
  {
    path: "/ingresos/exclusiones",
    name: "rhas.exceptions",
    component: () => import("@/views/rhas/Exceptions.vue"),
    meta: {
      title: "Exclusiones",
      middleware: UsrSystem,
    },
  },
  //insureds
  {
    path: "/asegurados",
    name: "insureds",
    component: () => import("@/views/insureds/Index.vue"),
    meta: {
      title: "Asegurados",
      middleware: UsrSystem,
    },
  },
  {
    path: "/asegurados/alta_pendiente_banco",
    name: "insureds.txt_accounts",
    component: () => import("@/views/insureds/TxtAccounts.vue"),
    meta: {
      title: "Asegurados | Alta pendiente en banco",
      middleware: UsrSystem,
    },
  },
  {
    path: "/asegurados/exceso_suma_asegurada",
    name: "insureds.self_insurance_excess_report",
    component: () => import("@/views/insureds/SelfInsuranceExcessReport.vue"),
    meta: {
      title: "Asegurados | Exceso de suma asegurada",
      middleware: UsrSystem,
    },
  },
  //providers
  {
    path: "/proveedores",
    name: "providers",
    component: () => import("@/views/providers/Index.vue"),
    meta: {
      title: "Proveedores",
      middleware: UsrSystem,
    },
  },
  {
    path: "/proveedores/alta_pendiente_banco",
    name: "providers.txt_accounts",
    component: () => import("@/views/providers/TxtAccounts.vue"),
    meta: {
      title: "Proveedores | Alta pendiente en banco",
      middleware: UsrSystem,
    },
  },
  //doctors
  {
    path: "/medicos",
    name: "doctors",
    component: () => import("@/views/doctors/Index.vue"),
    meta: {
      title: "Médicos",
      middleware: UsrSystem,
    },
  },
  {
    path: "/medicos/alta_pendiente_banco",
    name: "doctors.prb",
    component: () => import("@/views/doctors/Prb.vue"),
    meta: {
      title: "Médicos | Alta pendiente en banco",
      middleware: UsrSystem,
    },
  },
  //general
  {
    path: "/",
    name: "main",
    component: () => import("@/views/general/Main.vue"),
    meta: {
      title: "SVR",
    },
  },
  {
    path: "/iniciar_sesion",
    name: "login",
    component: () => import("@/views/general/Login.vue"),
    meta: {
      title: "Iniciar Sesión",
      middleware: Login,
    },
  },
  {
    path: "/inicio",
    name: "home",
    component: () => import("@/views/general/Home.vue"),
    meta: {
      title: "Inicio",
      middleware: Auth,
    },
  },
  {
    path: "/no_autorizado",
    name: "unauthorized",
    component: () => import("@/views/general/Unauthorized.vue"),
    meta: {
      title: "Acceso Denegado",
      middleware: Auth,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not_found",
    component: () => import("@/views/general/NotFound.vue"),
  },
];

export default routes;
